'use client'
import { AcceptPopup } from '@/components/AcceptPopup'
import { ConfirmationOfferPopup } from '@/components/ConfirmationOfferPopup'
import { ConfirmationPopup } from '@/components/ConfirmationPopup'
import { useInitialApp } from '@/domains/Account/hooks/InitialApp'
import { mainStore } from '@/domains/Account/store'
import { User } from '@/services/Api/generated'
import { POPUP_TYPE } from '@/store/Popup'
import { userStore } from '@/store/User'
import { observer } from 'mobx-react-lite'
import { FunctionComponent, PropsWithChildren } from 'react'

interface InitialAppProps extends PropsWithChildren {
  // Пользователь, полученный на сервере из cookie (getServerUser)
  initialUser?: User | null
}

export const InitialApp: FunctionComponent<InitialAppProps> = observer(
  ({ children, initialUser }) => {
    useInitialApp({ initialUser })

    return (
      <>
        {children}

        {mainStore.popup.activated === POPUP_TYPE.CONFIRM_POPUP ? (
          <ConfirmationPopup
            onClose={mainStore.popup.hidePopup}
            data={mainStore.popup.data}
          />
        ) : null}

        {mainStore.popup.activated === POPUP_TYPE.ACCEPT_POPUP ? (
          <AcceptPopup
            onClose={mainStore.popup.hidePopup}
            data={mainStore.popup.data}
          />
        ) : null}

        {userStore.uuid != null &&
        userStore.emailVerified &&
        userStore.agreementAccepted == null ? (
          <ConfirmationOfferPopup />
        ) : null}
      </>
    )
  }
)
